export const FIND_FEED_QUERY_PREFIX = ["find-feed"] as const;
